import React from 'react';
import { CheckCircle2Icon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { MockupImage } from './MockupImage';
import { TrustLine } from './TrustLine';
import { CHECKOUT_URL, COMPARE_PRICE, PRICE, PRODUCT, PRODUCT_TAGLINE } from '../data/constants';
const INCLUDED = ['6 modules visuels complémentaires', '5 bonus pratiques', 'Fondamentaux de l’ECG et anatomie électrique du cœur', 'Lecture systématique pas à pas (module central)', 'Arythmies et troubles de la conduction', 'Ischémie, infarctus et anomalies ECG', 'Surveillance cardiaque et rôle infirmier', 'Cas cliniques pédagogiques, exercices et corrigés', 'Méthode FRÉQUENCE › RYTHME › AXE › INTERVALLES › ST-T', 'Accès à vie • livraison numérique immédiate'];
export function Offer() {
  return <section id="offer" className="scroll-mt-2 bg-white py-5 sm:py-7" data-id="element-124" data-mp="2fboek2i8j8fc">
      <div className="mx-auto max-w-5xl px-4 sm:px-6" data-id="element-125" data-mp="2ad3fw7imswt0">
        <p className="mx-auto w-fit rounded-md bg-gold px-3 py-1 font-display text-xs font-extrabold uppercase tracking-widest text-navy sm:text-sm" data-id="element-126" data-mp="2acbjiuh7mv1o">
          OFFRE SPÉCIALE DE LANCEMENT
        </p>

        <div className="mt-2 overflow-hidden rounded-2xl border-[3px] border-dashed border-tech bg-white shadow-lg" data-id="element-127" data-mp="ui0o2kag9pcd">
          <div className="bg-navy p-3 text-center sm:p-5" data-id="element-128" data-mp="zj6hylfujinh">
            <h2 className="text-2xl leading-tight text-white sm:text-4xl" data-id="element-129" data-mp="13k9rkq7awig9">🫀 {PRODUCT}</h2>
            <p className="mx-auto mt-1 max-w-2xl font-display text-xs font-semibold uppercase leading-tight tracking-wide text-tech-light sm:text-base" data-id="element-130" data-mp="6uinq0d4dixs">
              {PRODUCT_TAGLINE}
            </p>
          </div>

          <div className="grid gap-3 p-3 sm:p-6 lg:grid-cols-[0.9fr_1.1fr] lg:items-center lg:gap-6" data-id="element-131" data-mp="ftcq67d4t3j9">
            <MockupImage data-id="element-132" data-mp="klxl5c7rxmod" />

            <div data-id="element-133" data-mp="kn8ml5dqyicb">
              <p className="font-heading text-lg font-extrabold leading-tight text-navy sm:text-xl" data-id="element-134" data-mp="3k8m1qwgne73m">
                Système visuel complet 6 en 1
              </p>
              <ul className="mt-1.5 grid gap-1" data-id="element-135" data-mp="3o8o1h02toqg9">
                {INCLUDED.map(item => <li key={item} className="flex items-start gap-2" data-id="element-136" data-mp="ve60y811zls8">
                    <CheckCircle2Icon className="mt-0.5 h-5 w-5 shrink-0 text-teal" aria-hidden="true" data-id="element-137" data-mp="qhflnmx2ou7v" />
                    <span className="text-sm font-medium leading-snug text-steel sm:text-base" data-id="element-138" data-mp="106h038nyz3jq">
                      {item}
                    </span>
                  </li>)}
              </ul>

              <div className="mt-3 rounded-xl border-2 border-tech bg-tech-soft px-3 py-2 text-center" data-id="element-139" data-mp="7i1pcybvf7e7">
                <p className="font-display text-sm font-extrabold uppercase leading-tight text-navy sm:text-base" data-id="element-140" data-mp="li2puco84ct5">
                  🔥 OBTENEZ {PRODUCT} AUJOURD’HUI —{' '}
                  <span className="text-steel line-through decoration-alert decoration-2" data-id="element-141" data-mp="hic26htzucsu">
                    {COMPARE_PRICE}
                  </span>{' '}
                  <span className="whitespace-nowrap font-heading text-3xl font-black text-tech sm:text-4xl" data-id="element-142" data-mp="1sucwsddjgvgi">
                    {PRICE}
                  </span>
                </p>
              </div>

              <div className="mt-3 flex flex-col items-center" data-id="element-143" data-mp="25eib8ni4umck">
                <CTAButton href={CHECKOUT_URL} data-id="element-144" data-mp="1qgzk5ehzfx1y">🫀 OUI ! JE VEUX L’ATLAS COMPLET</CTAButton>
                <TrustLine items={['Accès numérique immédiat', '🛡️ Garantie de 7 jours']} data-id="element-145" data-mp="1vfat7n0ge3j4" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}